/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_UpdatedInputs */

const en_orders_carrier_updated = /** @type {(inputs: Orders_Carrier_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier updated.`)
};

const es_orders_carrier_updated = /** @type {(inputs: Orders_Carrier_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista actualizado.`)
};

/**
* | output |
* | --- |
* | "Carrier updated." |
*
* @param {Orders_Carrier_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_updated = /** @type {((inputs?: Orders_Carrier_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_updated(inputs)
	return es_orders_carrier_updated(inputs)
});